<template>

  <t-page>

    <t-dialog-duplicate dialog-id="modal-duplicate-price-list" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">
        <t-input hide-label :status="status" v-model="formDuplicate.priceListId" hidden/>
        <t-input label="Tabela de Preços" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>
    </t-dialog-duplicate>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" :breadcrumb="breadcrumb"
                 @getPage="getPage">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.priceListNumber"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">
          <t-list-actions-default :form-path="currentPage.path" :id="item.priceListNumber" :userAuth="userAuth">

            <b-button @click="openDialogDuplicate(item.priceListId, item.name)"
                      class="opacity-6-hover"
                      v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                      title="Duplicar Tabela de Preços">
              <b-icon-files variant="primary"/>
            </b-button>

          </t-list-actions-default>

        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {TDialogDuplicate},
  name: 'PriceList',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Tabela de Preços"},
        {key: "company", label: "Empresa"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      formDuplicateShow: false,
      formDuplicate: {
        priceListId: 0,
        changeName: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [{text: 'Configurações', to: {name: 'customer-setting'}},]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    openDialogDuplicate(priceListId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.priceListId = priceListId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = origin

      this.openDialogForm('modal-duplicate-price-list')

    },

    async onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicada", "Nova tabela de preços <b>" + item.name + "</b> duplicada com sucesso!", "success", "b-toaster-top-center", true)

      await this.goPath('business/price-list/' + item.priceListNumber)


    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
